export function onDOMContentLoaded(callback) {
  if (typeof callback !== 'function') {
    throw new Error('Callback must be a function');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

export function addOnClosestListener(event, selector, callback) {
  const supportedEvents = ['click', 'mouseover', 'mouseout', 'focus', 'blur', 'keydown', 'keyup'];
  if (!supportedEvents.includes(event)) {
    throw new Error('Invalid event type: must be one of click, mouseover, mouseout, focus, or blur');
  }

  if (typeof selector !== 'string' || typeof callback !== 'function') {
    throw new Error('Invalid arguments: selector must be a string and callback must be a function');
  }

  document.addEventListener(event, (event) => {
    const element = event.target.closest(selector);
    if (element) {
      callback(element, event);
    }
  });
}
